import { useContext } from 'react';

import { Preloader } from 'context';

const usePreloader = () => useContext(Preloader.Context);

export default usePreloader;
